var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_grid_path: "/teachers/events/statistic/grid",
          defaultOrderColumn: "start_at",
          hide_actions: "true",
          column_formats: {
            start_at: function (value) {
              return this$1.formatDateTime(value)
            },
            end_at: function (value) {
              return this$1.formatDateTime(value)
            },
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }